import { createReducer, on } from "@ngrx/store";

import { LabelPrinterActions } from './label-printers.actions';

import { initialState, labelPrintersAdapter } from "./label-printers.state";
import { LoadingState } from "@core/models";


export const labelPrintersReducer = createReducer(
  initialState,

  on(LabelPrinterActions.reset, (state) => ({ ...initialState })),

  on(LabelPrinterActions.add, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(LabelPrinterActions.addSuccess, (state, { labelPrinter }) => {
    return labelPrintersAdapter.upsertOne(labelPrinter, { ...state, callState: LoadingState.LOADED });
  }),
  on(LabelPrinterActions.addFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(LabelPrinterActions.remove, (state, { command }) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(LabelPrinterActions.removeSuccess, (state, { id }) => {
    return labelPrintersAdapter.removeOne(id, { ...state, callState: LoadingState.LOADED });
  }),
  on(LabelPrinterActions.removeFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  on(LabelPrinterActions.update, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(LabelPrinterActions.updateSuccess, (state, { labelPrinter }) => {
    return labelPrintersAdapter.upsertOne(labelPrinter, { ...state, callState: LoadingState.LOADED });
  }),
  on(LabelPrinterActions.updateFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  // Load All
  on(LabelPrinterActions.load, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(LabelPrinterActions.loadSuccess, (state, { labelPrinters }) => {
    return labelPrintersAdapter.setAll(labelPrinters, { ...state, callState: LoadingState.LOADED });
  }),
  on(LabelPrinterActions.loadFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),

  // Get
  on(LabelPrinterActions.get, (state) => ({
    ...state,
    callState: LoadingState.LOADING,
  })),
  on(LabelPrinterActions.getSuccess, (state, { labelPrinter }) => {
    return labelPrintersAdapter.upsertOne(labelPrinter, { ...state, callState: LoadingState.LOADED });
  }),
  on(LabelPrinterActions.getFailure, (state, { error }) => ({
    ...state, callState: { errorMsg: error.message }
  })),
);